var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      !_vm.showInstaller
        ? _c(
            "v-layout",
            { attrs: { wrap: "", xs12: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c(
                    "v-flex",
                    {
                      staticStyle: {
                        "font-weight": "bold",
                        "font-size": "16px",
                      },
                      attrs: { xs4: "" },
                    },
                    [
                      _vm._v(
                        "\n            Please check our support article below for more details on why you are seeing this page.  \n            "
                      ),
                      _c("p"),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { staticStyle: { "font-weight": "bold", "font-size": "16px" } },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.brandingService.getSupportUrl("adminGuide"),
                        target: "_blank",
                      },
                    },
                    [_vm._v("Admin Guide")]
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showInstaller
        ? _c(
            "v-layout",
            { attrs: { wrap: "", "justify-center": "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs10: "" } },
                [_c("collector-install-panel", { attrs: { mode: "install" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }